var map = {
	"./ic-announcement-active.svg": "e1de",
	"./ic-devices-active.svg": "a636",
	"./ic-layouts-active.svg": "9a33",
	"./ic-media-active.svg": "ecac",
	"./ic-playlists-active.svg": "035a",
	"./ic-screens-active.svg": "0c70",
	"./ic-smartplug-active.svg": "0d96",
	"./ic-stats-active.svg": "fa1f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "47eb";